export default "__VITE_ASSET__BNj8h$Gq__"